import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'



export const getDaftarBahanBaku = createAsyncThunk('/bahan_baku/content', async (nopage) => {
    const userId = localStorage.getItem("userId");
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/daftarbahanbaku/${userId}?page=${nopage}`, {})
    
    return response.data;
})

export const daftarbahanbakuSlice = createSlice({
    name: 'bahan_baku',
    initialState: {
        isLoading: false,
        bahan_baku : []
    },

    /*extraReducers: {
        [getDaftarBahanBaku.pending]: state => {
			state.isLoading = true
		},
        [getDaftarBahanBaku.fulfilled]: (state, action) => {
            state.bahan_baku = action.payload.data
			state.isLoading = false
		},
        [getDaftarBahanBaku.rejected]: state => {
			state.isLoading = false
		},
    }*/
    extraReducers: (builder) => {
        builder
          .addCase(getDaftarBahanBaku.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(getDaftarBahanBaku.fulfilled, (state, action) => {
            state.bahan_baku = action.payload.data;
            state.isLoading = false;
          })
          .addCase(getDaftarBahanBaku.rejected, (state) => {
            state.isLoading = false;
          });
      },
})


export default daftarbahanbakuSlice.reducer